import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div<{ width?: number; height?: number }>`
  border-radius: ${rem(8)};
  overflow: hidden;
  padding: ${rem(8)};
  background: "inherit";
  width: '100%';
  height: ${({ height }) => rem(height) ?? rem(500)};
`;

export default { Wrapper };
